<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <sidebar-tree></sidebar-tree>
    </nav>
  </div>
</template>
<script>
import SidebarFooter from "./SidebarFooter";
import SidebarForm from "./SidebarForm";
import SidebarHeader from "./SidebarHeader";
import SidebarMinimizer from "./SidebarMinimizer";
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import SidebarTree from "./common/SideTree";
export default {
  name: "sidebar",
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarTree,
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
  },
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue